module.exports = __webpack_public_path__ + "img/003-facebook.a59819be.svg";